/** Whether POS checkout/refund may proceed without a live access token. */
export function canSubmitOfflineSale(opts: {
  accessToken: string;
  usesLocalCatalog: boolean;
  sessionMode?: 'online' | 'offline';
  isOnline: boolean;
}): boolean {
  if (opts.accessToken) return true;
  if (!opts.usesLocalCatalog) return false;
  return opts.sessionMode === 'offline' || !opts.isOnline;
}
